import { Controller } from "@hotwired/stimulus"

// registration step `residence.html.erb` の「radio 選択 → 即 form submit」controller (#1833 PR 8a)。
//
// 旧 inline JS は radio change で `this.closest('label')` の <div> に opacity-50 を付けて
// loading 表示 + `form.requestSubmit()` で送信していた。同 logic を controller 化。
//
// scope: form 自体に data-controller を置く (radio 全部 + form を 1 scope で扱える)。
// 旧 view の `id="residence-form"` 依存を Stimulus scope に置換。
//
// Rule of Three: residence 1 view 専用、opacity / class 名は hardcoded で問題なし。
// 将来他 step で radio instant-submit が出てきたら共通化を再考。
//
// targets: 宣言なし。`event.target` で操作対象の radio を取得できるため、`this.radioTargets`
// 経由のアクセスは不要。view 側は `data-action="change->...#submitOnChange"` のみで wiring。
export default class extends Controller {
  submitOnChange(event) {
    const radio = event.target
    if (!radio.checked) return

    // 選択した radio の親 label 内 <div> に loading 状態を付与 (旧 inline JS parity)
    const label = radio.closest("label")
    if (label) {
      const inner = label.querySelector("div")
      if (inner) inner.classList.add("opacity-50")
    }

    this.element.requestSubmit()
  }
}
